// @flow

"use strict";

/**
 * フレーム内からフレーム外へデータを渡すDTO
 */
export default class InnerToOuterDto {
  constructor(widgetId: string, uuid: string, widgetHeight: number, inviewRequestURL: string, inviewPointPixel: string) {
    this.widgetId = widgetId;
    this.uuid = uuid;
    this.widgetHeight = widgetHeight;
    this.inviewRequestURL = inviewRequestURL;
    this.inviewPointPixel = inviewPointPixel;
  }

  static create(widgetId: string, uuid: string, widgetHeight: number, inviewRequestURL: string, inviewPointPixel: string): InnerToOuterDto{
    return new InnerToOuterDto(widgetId, uuid, widgetHeight, inviewRequestURL, inviewPointPixel);
  }

  /**
   * Json文字列からオブジェクトを生成
   * @param string
   * @returns {InnerToOuterDto}
   */
  static fromStringJson(string: string): InnerToOuterDto{
    try {
      const json = JSON.parse(decodeURIComponent(string));
      return new InnerToOuterDto(json.widgetId, json.uuid, json.widgetHeight, json.inviewRequestURL, json.inviewPointPixel);
    } catch (e) {
      throw new Error(`json parse error. value:${decodeURIComponent(string)}`);
    }

  }

  /**
   * オブジェクトをJson文字列にして返却
   * @returns {string}
   */
  toJsonString(): string{
    const json = {
      widgetId: this.widgetId,
      uuid: this.uuid,
      widgetHeight: this.widgetHeight,
      inviewRequestURL: this.inviewRequestURL,
      inviewPointPixel: this.inviewPointPixel,
    };
    return encodeURIComponent(JSON.stringify(json));
  }
}


// WEBPACK FOOTER //
// ./src/js/model/dto/inner-to-outer-dto.js